import Breakpoints from './breakpoints';
import Colors from './colors';
import FontSizes from './fontSizes';
import GlobalStyles from './globalStyles';
import CommonStyles from './commonStyle';

export { Breakpoints, Colors, FontSizes, GlobalStyles, CommonStyles };



// WEBPACK FOOTER //
// ./src/styles/index.js